module.exports = __webpack_public_path__ + "fc26f33eac3c989359d8c5b16aad17ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/default.png
// module id = 117
// module chunks = 0